import {Fragment} from 'react';
import {connect} from 'react-redux';

import {getAvailableCategories} from '../../../../../general/selectors';
import {getAvailableIndices} from '../../../../selectors';

import Info from './Info';

const Content = ({timezone, categories, indices}) => (
    <Fragment>
        <Info Element="thead" timezone={timezone} />
        <Info Element="tfoot" timezone={timezone} />
        {categories.map(({id, products}) => (
            <tbody key={id} className="product-category">
                {products.map(({id, title}) => (
                    <tr key={id}>
                        <td className="product-title">
                            <span className="product-title-txt">
                                {title}
                            </span>
                        </td>
                    </tr>
                ))}
                <tr className="product-category-spacer">
                    <td colSpan={indices.length + 1} />
                </tr>
            </tbody>
        ))}
    </Fragment>
);

const mapStateToProps = state => ({
    categories: getAvailableCategories(state),
    indices: getAvailableIndices(state),
    timezone: state.timezone,
});

export default connect(mapStateToProps)(Content);
